import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

import { AddonsTable } from './AddonsTable';

const AddonsSalesTaxTableComponent = ({ intl, ...restProps }) => {
  const tableHeaders = [
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_addons_table.item', defaultMessage: 'Add-ons' }),
      classname: 'flex-basis-20 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_addons_table.pre_tax_amount', defaultMessage: 'Pre-Tax Amount (Diff)' }),
      classname: 'flex-basis-20 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_addons_table.tax_rate', defaultMessage: 'Tax Rate' }),
      classname: 'flex-basis-10 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_addons_table.sales_tax_amount', defaultMessage: 'Sales Tax Amount (Diff)' }),
      classname: 'flex-basis-20 text-transform-none'
    },
    {
      label: intl.formatMessage({ id: 'hosting.sales_tax_addons_table.total', defaultMessage: 'Total (Diff)' }),
      classname: 'flex-basis-15 text-transform-none'
    }
  ];

  return (
    <AddonsTable
      {...restProps}
      headers={tableHeaders}
      title={<FormattedMessage id="hosting.sales_tax_addons_table.item" defaultMessage="Add-ons" />}
    />
  );
};

AddonsSalesTaxTableComponent.propTypes = {
  total: PropTypes.number,
  taxTotal: PropTypes.number,
  totalWithTax: PropTypes.number,
  items: PropTypes.array,
  currency: PropTypes.string,
  intl: intlShape
};

export const AddonsSalesTaxTable = injectIntl(AddonsSalesTaxTableComponent);
